// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:09:26

export default {
  "id": "mega-makeup-seasons-best",
  "slug": "mega-makeup-seasons-best",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/7c05278108ea463d8c783cac41444d9d-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/7c05278108ea463d8c783cac41444d9d/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Mega Makeup - Seasons Best",
      "description": "Mega Makeup Seasons Best is the ultimate makeup game where creativity knows no bounds! Design stunning looks for each month of the year with vibrant eyeshadows, bold lipsticks, sparkling gems, and stylish accessories. Choose between Pro Mode for precision or Freestyle Mode for endless color combinations. Complete your seasonal masterpiece with matching jewelry and hair accessories. Perfect for makeup enthusiasts, this game is your go-to for all things beauty and style! Play now!",
      "instructions": "Use your mouse to play this game on a desktop, tap to play on mobile devices.",
      "genres": [
        "Dress-up"
      ],
      "tags": [
        "beauty",
        "girls",
        "makeover",
        "makeup",
        "season"
      ]
    },
    "zh-CN": {
      "title": "巨美妆 - 季节最佳",
      "description": "Mega Makeup Seasons Best是一款终极化妆游戏，创意无极限！为一年中的每个月份设计令人惊叹的外观，使用鲜艳的眼影、大胆的口红、闪耀的宝石和时尚的配饰。选择专业模式以获得精确度或自由模式以获得无尽的色彩组合。用匹配的珠宝和发饰完成您的季节性杰作。适合化妆爱好者，这款游戏是您追求美丽和时尚的必备之选！现在就玩！",
      "instructions": "使用鼠标在桌面电脑上玩游戏，在移动设备上轻触屏幕进行游戏。",
      "genres": [
        "装扮"
      ],
      "tags": [
        "美丽",
        "女孩",
        "化妆",
        "妆容",
        "季节"
      ]
    },
    "zh-TW": {
      "title": "Mega Makeup - 季節最佳",
      "description": "Mega Makeup Seasons Best 是一款無限創意的終極妝容遊戲！為一年中的每一個月設計驚艷的妝容，使用豐富的眼影、顏色鮮豔的唇膏、閃耀的寶石和時尚的配飾。在專業模式中追求精準，或在自由模式中無限組合顏色。用相匹配的首飾和頭飾完成每季的杰作。適合妝容愛好者，這款遊戲是您尋找所有美妝和風格的絕佳選擇！現在就開始遊戲！",
      "instructions": "使用滑鼠在桌面上遊戲，在移動設備上點擊以遊戲。",
      "genres": [
        "裝扮"
      ],
      "tags": [
        "美麗",
        "女孩",
        "變裝",
        "妝容",
        "季節"
      ]
    },
    "zh-HK": {
      "title": "美妝大師 - 季節之選",
      "description": "Mega Makeup Seasons Best係最終極嘅化妝遊戲，創意無邊界！為咗每年嘅每月設計驚為天嘅造型，用上生動眼影、鮮艷唇膏、閃耀嘅寶石同時尚配飾。你可以選擇專業模式追求精準，或者自由模式無限組合顏色。用配搭嘅首飾同髮飾完成你嘅季節杰作。完美適合化妝愛好者，呢個遊戲係你尋美妝同時尚嘅不二之選！即刻開始玩！",
      "instructions": "使用滑鼠於桌面玩遊戲，按鍵於手機設備上玩遊戲。",
      "genres": [
        "装扮"
      ],
      "tags": [
        "美麗",
        "女兒",
        "化妝",
        "妝容",
        "季節"
      ]
    },
    "ja": {
      "title": "メガメイクアップ - セゾンズベスト",
      "description": "Mega Makeup Seasons Bestは、創造性に限界がない究極のメイクアップゲームです！鮮やかなアイシャドウ、大胆なリップスタイン、輝く宝飾品、スタイリッシュなアクセサリーを使って、年の月ごとに美しいルックをデザインしましょう。プロモードの精度か、フリースタイルモードの無限の色の組み合わせをお選びください。シーズナルの傑作をマッチングした宝石やヘアアクセサリーで完成させましょう。メイクアップの愛好家に最適で、美とスタイルに関するすべてのものに対するお手本となるゲームです！今すぐ遊んでください！",
      "instructions": "デスクトップではマウスを使用してこのゲームをプレイし、モバイルデバイスではタップでプレイしてください。",
      "genres": [
        "ドレスアップ"
      ],
      "tags": [
        "美しさ",
        "娘たち",
        "メイクオーバー",
        "メイクアップ",
        "季節"
      ]
    },
    "ko": {
      "title": "메가 메이크업 - 시즌 베스트",
      "description": "메가 메이크업 시즌 베스트는 창의성을 제한 없이 발휘할 수 있는 최종적인 메이크업 게임입니다! 생동감 넘치는 아이슈아이, 강한 립스틱, 빛나는 보석, 풍성한 액세서리로 매월 다른 멋진 외관을 디자인하세요. 정확성을 추구하는 프로 모드와 끝없는 컬러 조합을 즐길 수 있는 프리스타일 모드 중 하나를 선택하세요. 시즌별 마스터피스를 매치된 조elry와 머리 액세서리로 완성하세요. 메이크업 애호가들에게 딱 맞는 이 게임은 미용과 스타일 모든 것에 대해 가르쳐줍니다! 지금 즐겨보세요!",
      "instructions": "데스크톱에서는 마우스로 게임을 플레이하세요. 모바일 장치에서는 탭하여 플레이하세요.",
      "genres": [
        "의상장식"
      ],
      "tags": [
        "미인",
        "소녀",
        "변신",
        "메이크업",
        "계절"
      ]
    },
    "fr": {
      "title": "Mega Makeup - Meilleure saison",
      "description": "Mega Makeup Seasons Best est le jeu de maquillage ultime où la créativité n'a pas de limites ! Conceivez des looks époustouflants pour chaque mois de l'année avec des fards à paupières vibrants, des rouges à lèvres audacieux, des bijoux scintillants et des accessoires stylés. Choisissez entre le Mode Pro pour une précision parfaite ou le Mode Libre pour des combinaisons de couleurs illimitées. Terminez votre œuvre saisonnière avec des bijoux et des accessoires de cheveux coordonnés. Idéal pour les passionnés de maquillage, ce jeu est votre point de référence pour tout ce qui concerne la beauté et le style ! Jouez maintenant !",
      "instructions": "Utilisez votre souris pour jouer à ce jeu sur un ordinateur de bureau, appuyez pour jouer sur les appareils mobiles.",
      "genres": [
        "Dress-up"
      ],
      "tags": [
        "beauté",
        "filles",
        "transformation",
        "maquillage",
        "saison"
      ]
    }
  }
};
